import { createElement } from 'react'

export const customerRoutesData: IRouteDataV2[] = [

]
